import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "@/components/dashboard/DashboardPage";
import { useSetPageContext } from "@/hooks/use-page-context";

export const Route = createFileRoute("/_app/_/")({
	component: DashboardRoute,
});

function DashboardRoute() {
	useSetPageContext({
		page_key: "dashboard",
		page_title: "Dashboard",
		available_actions: ["create_task", "generate_content", "get_task_list"],
		current_data_summary: null,
	});

	return <DashboardPage />;
}
